/*
 * @Author: kaifei.shang(尚锴飞) kaifei.shang@advantech.com.cn
 * @Date: 2023-03-09 14:41:31
 * @LastEditors: kaifei.shang(尚锴飞) kaifei.shang@advantech.com.cn
 * @LastEditTime: 2023-09-25 13:14:05
 * @FilePath: /eSpareParts-Portal/src/config/global.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const ROLE_TYPE = {
  SUPERADMIN: 'superadmin',
  PARTSSUPERADMIN: 'partsSuperAdmin',
  ADMIN: 'admin',
  USER: 'user'
}

export const APP_NAME = 'AssetManagement'
export const APP_VERSION = 'v1.8.3'